import React, { useEffect, useRef } from 'react';

import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';

import {
  ClientChatTypes,
  createChatFromPharmacy,
  getPharmacyChannelUrl,
  pharmacistBookingDetails,
  resetChatValues,
  setChatActiveTab,
  TypeOfUser,
} from '@pharmaplan/common';

import { ReactComponent as ChatIcon } from '../../../../../assets/svg/innerChatIcon.svg';
import { useAppSelector } from '../../../../../hooks/useAppSelector';
import { useAppDispatch } from '../../../../../hooks/useAppDispatch';
import { Constants } from '../../../../../helpers/Constants';

const GoToPharmacistChat = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const createRef = useRef(false);
  const url = useAppSelector(getPharmacyChannelUrl);

  const details = useAppSelector(pharmacistBookingDetails);
  const { professionalId, firstName, lastName } = details ?? {};

  const goToChat = () => {
    dispatch(setChatActiveTab(ClientChatTypes.pharmacist));
    navigate(Constants.paths.chat, {
      state: {
        personnelId: professionalId,
        url,
        channelName: ` / ${firstName} ${lastName}`,
        userType: TypeOfUser.pharmacist,
      },
    });
  };

  const createChat = () => {
    dispatch(createChatFromPharmacy(professionalId ?? ''));
    createRef.current = true;
  };

  useEffect(() => {
    if (url && createRef.current) {
      dispatch(resetChatValues(['pharmacyChannelUrl']));
      goToChat();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  return (
    <IconButton onClick={createChat}>
      <ChatIcon />
    </IconButton>
  );
};

export default GoToPharmacistChat;
